export function sanitizeHtml(input) {
    const tagBlackList = {
        'SCRIPT': true
    }

    const attributeWhitelist = {
        'href': true,
        'src': true,
        'target': true
    }

    const iframe = document.createElement('iframe')
    if (iframe['sandbox'] === undefined) {
        console.warn("Unable to sanitize html.")
        return
    }

    iframe['sandbox'] = 'allow-same-origin'
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    iframe.contentDocument.body.innerHTML = input

    function makeSanitizedCopy(node) {
        let newNode
        if (node.nodeType == Node.TEXT_NODE) {
            newNode = node.cloneNode(true)
        } else if (node.nodeType == Node.ELEMENT_NODE && !tagBlackList[node.tagName]) {
            newNode = iframe.contentDocument.createElement(node.tagName)
            for (var i = 0; i < node.attributes.length; i++) {
                const attr = node.attributes[i];
                if (attributeWhitelist[attr.name]) {
                    newNode.setAttribute(attr.name, attr.value);
                }
            }
            for (i = 0; i < node.childNodes.length; i++) {
                const subCopy = makeSanitizedCopy(node.childNodes[i]);
                newNode.appendChild(subCopy, false);
            }
        } else {
            newNode = document.createDocumentFragment()
        }
        return newNode
    }

    const resultElement = makeSanitizedCopy(iframe.contentDocument.body)
    document.body.removeChild(iframe)
    return resultElement.innerHTML
}

export function fetchThumbnailUrl(input) {
    const iframe = document.createElement('iframe')
    if (iframe['sandbox'] === undefined) {
        console.warn("Unable to fetch thumbnail URL.")
        return
    }
    iframe['sandbox'] = 'allow-same-origin'
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    iframe.contentDocument.body.innerHTML = input

    function findImageUrl(node) {
        let imageUrl = ''
        if (node.nodeType == Node.ELEMENT_NODE && node.tagName == 'IMG' && node.getAttribute('src')) {
            imageUrl = node.getAttribute('src')
        } else {
            for (var i = 0; i < node.childNodes.length && !imageUrl; i++) {
                imageUrl = findImageUrl(node.childNodes[i])
            }
        }
        return imageUrl
    }

    const url = findImageUrl(iframe.contentDocument.body)
    document.body.removeChild(iframe)
    return url
}

export function cropHtml(input, characterLimit) {
    const tagBlackList = {
        'IMG': true,
        'BR': true,
        'IFRAME': true,
        'VIDEO': true,
        'BLOCKQUOTE': true
    }

    const iframe = document.createElement('iframe')
    if (iframe['sandbox'] === undefined) {
        console.warn("Unable to crop html.")
        return input
    }

    iframe['sandbox'] = 'allow-same-origin'
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
    iframe.contentDocument.body.innerHTML = input

    function makeCroppedCopy(node, limit) {
        let newNode, newCharacterLimit
        newCharacterLimit = limit

        if (node.nodeType == Node.TEXT_NODE) {
            if (node.textContent.length <= newCharacterLimit) {
              newNode = node.cloneNode(true)
              newCharacterLimit = newCharacterLimit - node.textContent.length
            }
            else {
              const slicedText = node.textContent.slice(0,newCharacterLimit)
              const lastIndex = slicedText.lastIndexOf(" ")
              const croppedText = slicedText.substring(0, lastIndex)

              newNode = iframe.contentDocument.createTextNode(croppedText + '...')
              newCharacterLimit = 0
            }
        } else if (node.nodeType == Node.ELEMENT_NODE && !tagBlackList[node.tagName]) {
            newNode = iframe.contentDocument.createElement(node.tagName)
            for (var i = 0; i < node.attributes.length; i++) {
                const attr = node.attributes[i]
                newNode.setAttribute(attr.name, attr.value)
            }
            if(node.tagName == 'A' && node.getAttribute('href')) {
              newNode.setAttribute('target','_blank')
            }
            for (var i = 0; i < node.childNodes.length && newCharacterLimit > 0; i++) {
                let subCopy = makeCroppedCopy(node.childNodes[i],newCharacterLimit)
                newNode.appendChild(subCopy[0], false)
                newCharacterLimit = subCopy[1]
            }
        } else {
            newNode = document.createDocumentFragment()
        }
        return [newNode, newCharacterLimit]
    }

    const resultElement = makeCroppedCopy(iframe.contentDocument.body, characterLimit)
    document.body.removeChild(iframe)
    return resultElement[0].innerHTML
}
;



// WEBPACK FOOTER //
// ./src/utils/Feed.js